"use client";

import { getVideoEmbedUrl } from "@/lib/utils";

interface VideoParams {
    autoPlay?: boolean;
    initiallyMuted?: boolean;
    disableSeeking?: boolean;
    shouldShowCaptionsInitially?: boolean;
    disableHls?: boolean;
    lang?: string;
    mode?: "video" | "lomda";
}

export default function Video({
    pullZone,
    videoId,
    params,
}: {
    pullZone: string;
    videoId: string;
    params: VideoParams;
}) {
    const paramsList = [];

    if (params.autoPlay) {
        paramsList.push("autoPlay=true");
    }
    if (params.initiallyMuted) {
        paramsList.push("muted=true");
    }
    if (params.shouldShowCaptionsInitially) {
        paramsList.push("captions=true");
    }
    if (params.disableSeeking) {
        paramsList.push("disableSeeking=true");
    }
    if (params.disableHls) {
        paramsList.push("disableHls=true");
    }
    if (params.lang) {
        paramsList.push(`lang=${params.lang}`);
    }
    if (params.mode === "lomda") {
        paramsList.push("mode=lomda");
    }

    let embedUrl = getVideoEmbedUrl(pullZone!, videoId);

    if (paramsList.length) {
        embedUrl += `?${paramsList.join("&")}`;
    }

    return (
        <iframe
            src={embedUrl}
            className="aspect-video w-full rounded-md"
            allow="microphone"
            allowFullScreen
        />
    );
}
